import { v4 as getUuid } from 'uuid';

export const instanceId = getUuid();
